import React from 'react';
import { inject, observer } from 'mobx-react';
import { Flex } from 'grid-styled';

import HomeModel from '../models/HomeModel';
import StreamModel from '../models/StreamModel';

import Streaming from '../sections/Streaming';
import Encoding from '../sections/Encoding';
import Capture from '../sections/Capture';
import IcecastStatistics from '../sections/IceCastStatistics';
import LicenseHome from '../sections/LicenseHome';
import IcecastRelay from '../sections/IcecastRelay';

class Home extends React.Component {
    componentWillMount() {
        const { session } = this.props;
        this.model = new HomeModel(session);
        this.model.load();

        this.modelStream = new StreamModel(session);
        this.modelStream.load();
    }

    changeStateActions = () => {};

    render() {
        return (
            <Flex flexWrap="wrap">
                <Capture model={this.modelStream} />
                <Streaming model={this.model} />
                <Encoding model={this.modelStream} />
                <LicenseHome session={this.props} />
                <IcecastStatistics session={this.props} />
                <IcecastRelay />
            </Flex>
        );
    }
}

export default inject('session')(observer(Home));



// WEBPACK FOOTER //
// ./src/pages/Home.js